<template>
  <div class="loaded-group">
    <div
      class="group-content"
      @click="getDiaries(group)">
      <i
        v-if="isError"
        class="material-icons group-content-error">error_outline</i>
      <i
        v-else-if="isLoading"
        class="material-icons rotate-icon">rotate_right</i>
      <i
        v-else-if="group.isLoaded"
        class="material-icons" />
      <i
        v-else
        class="material-icons">keyboard_arrow_right</i>
      <span :class="['group-content-value', {'group-content-active': $store.state.selectedGroupId === group.id, 'group-content-error': isError}]">
        <i class="material-icons">folder</i>
        <span class="label">{{ group.name }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * このコンポーネントで扱うグループの情報
     */
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      /**
       * フォルダ読み込み中フラグ
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * フォルダエラーフラグ
       * @type {Boolean}
       */
      isError: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (localStorage.getItem('selectedGroupId') === this.group.id) {
        this.getDiaries(this.group)
      }
    })
  },
  methods: {
    /**
     * 選択したグループの日報を取得する
     * @param {Object} group 選択されたグループ
     */
    async getDiaries (group) {
      if (this.isLoading || this.$store.state.selectedGroupId === group.id) return
      this.isError = false
      this.isLoading = true
      try {
        this.$store.commit('setSelectedGroupId', group.id)
        this.$store.commit('setSelectedUserId', '')
        if (group.isLoaded) {
          this.$store.commit('setSelectedUsers', group.children.users)
          return
        }
        await this.$store.dispatch('getChildrenUsers', group)
        this.$store.commit('setSelectedUsers', group.children.users)
        // グループにユーザーがいない場合
        if (this.$store.state.selectedGroupId && group.children.users.length === 0) {
          this.$store.commit('setIsNoUsersInSelectedGroup', true)
        } else {
          this.$store.commit('setIsNoUsersInSelectedGroup', false)
        }
        await this.$store.dispatch('getUsers')
        await this.$store.dispatch('getDiaries')
      }
      catch (error) {
        this.isError = true
        console.error(error)
      }
      finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scope>
.loaded-group {
  padding: 0 0 0 1px;
}
.group-content{
  height: 32px;
  max-width: 100%;
  padding: 0;
  display: inline-flex;
  font-size: 0.9em;
}
.group-content-value {
  color: #666;
  white-space: nowrap;
  margin: 0;
  vertical-align: top;
  line-height: 30px;
  height: 32px;
  cursor: pointer;
}
.loaded-group .material-icons {
  display: inline-flex;
  vertical-align: middle;
  height: 24px;
  width: 24px;
  margin: auto 0;
  color: #666;
}
.rotate-icon {
  display: inline-block;
  animation: rotate-anime 0.5s linear;
  animation-iteration-count: infinite;
}
.group-content-value:hover {
  background: #e7f4f9;
}
.loaded-group .group-content-error {
  color: red;
}
.loaded-group .group-content-active {
  color: #039be5;
}
.label {
  line-height: 1;
  vertical-align: middle;
}
@keyframes rotate-anime {
  100%{ transform: rotate(360deg) }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/DailyReport/MenuGroupSelect.vue